/* ============================================================
   Collection Menu — assets/collection-menu.js
   Cart logic modelled on the proven /cart/add.js pattern:
   add → refetch /cart.js → update bubbles → broadcast events.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var moneyFormat = '₹{{amount}}';

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    var fmt = format || moneyFormat;
    var value = (cents || 0) / 100;

    function group(num, decimals, thousands, decimalSep) {
      var parts = num.toFixed(decimals).split('.');
      var intPart = parts[0];
      var decPart = parts[1] ? decimalSep + parts[1] : '';
      var last3 = intPart.slice(-3);
      var rest = intPart.slice(0, -3);
      if (rest) {
        last3 = thousands + last3;
        rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, thousands);
      }
      return rest + last3 + decPart;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        default: return group(value, 2, ',', '.');
      }
    });
  }

  /* ---------------- Toast ---------------- */
  var toastEl, toastTimer;
  function toast(msg, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cmenu-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.toggle('is-error', !!isError);
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2000);
  }

  /* ---------------- Icons ---------------- */
  var ICON_CART = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
  var ICON_TICK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  /* ---------------- Cart ---------------- */
  function refreshCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #CartCount')
          .forEach(function (b) {
            var span = b.querySelector('span') || b;
            span.textContent = cart.item_count;
            if (cart.item_count > 0) b.removeAttribute('hidden');
          });
        renderCartBar(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cmenu:cart:updated', { detail: cart }));
        return cart;
      });
  }

  function addToCart(variantId, quantity) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart');
          return body;
        });
      })
      .then(refreshCart);
  }

  function runAdd(btn, variantId) {
    if (btn.disabled) return;
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-busy');

    addToCart(variantId, 1)
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.innerHTML = ICON_TICK + '<span>Added</span>';
        toast('Added to cart');
        setTimeout(function () {
          btn.classList.remove('is-done');
          btn.innerHTML = original;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.innerHTML = original;
        btn.disabled = false;
        toast(err.message || 'Could not add to cart', true);
      });
  }

  /* ---------------- Variant modal ---------------- */
  var Modal = {
    el: null, list: null, title: null, lastFocus: null,

    init: function () {
      this.el = document.getElementById('cmenu-modal');
      if (!this.el) return;
      this.list = document.getElementById('cmenu-modal-list');
      this.title = document.getElementById('cmenu-modal-title');

      var self = this;
      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-cmenu-close]')) self.close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.el.hidden) self.close();
      });
    },

    open: function (productTitle, variants) {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.title.textContent = productTitle;
      this.list.innerHTML = '';

      variants.forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'cmenu-variant' + (v.available ? '' : ' is-unavailable');

        var price = v.compare_at_price > v.price
          ? '<s>' + formatMoney(v.compare_at_price) + '</s> ' + formatMoney(v.price)
          : formatMoney(v.price);

        row.innerHTML =
          (v.image ? '<img class="cmenu-variant__img" src="' + v.image + '" alt="" width="56" height="56">' : '') +
          '<div class="cmenu-variant__info">' +
            '<span class="cmenu-variant__name"></span>' +
            '<span class="cmenu-variant__price">' + price + '</span>' +
          '</div>';
        row.querySelector('.cmenu-variant__name').textContent = v.title;

        if (v.available) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cmenu-btn cmenu-btn--sm';
          b.setAttribute('data-cmenu-add', '');
          b.dataset.variantId = v.id;
          b.innerHTML = '<span>Add to cart</span>' + ICON_CART;
          row.appendChild(b);
        } else {
          var s = document.createElement('span');
          s.className = 'cmenu-variant__oos';
          s.textContent = 'Sold out';
          row.appendChild(s);
        }
        this.list.appendChild(row);
      }, this);

      this.el.hidden = false;
      document.body.classList.add('cmenu-locked');
      var first = this.list.querySelector('button');
      if (first) first.focus();
    },

    close: function () {
      if (!this.el || this.el.hidden) return;
      this.el.hidden = true;
      document.body.classList.remove('cmenu-locked');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  };

  /* ---------------- Sticky cart bar ---------------- */
  function renderCartBar(cart) {
    var bar = document.getElementById('cmenu-cartbar');
    if (!bar || !cart) return;
    if (!cart.item_count) { bar.hidden = true; return; }

    var thumbs = document.getElementById('cmenu-cartbar-thumbs');
    thumbs.innerHTML = '';
    cart.items.slice(0, 3).forEach(function (item) {
      if (!item.image) return;
      var img = document.createElement('img');
      img.src = item.image.replace(/(\.[^.?]*)(\?|$)/, '_80x$1$2');
      img.alt = ''; img.width = 32; img.height = 32;
      thumbs.appendChild(img);
    });
    if (cart.items.length > 3) {
      var more = document.createElement('span');
      more.className = 'cmenu-cartbar__more';
      more.textContent = '+' + (cart.items.length - 3);
      thumbs.appendChild(more);
    }

    document.getElementById('cmenu-cartbar-count').textContent =
      cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    document.getElementById('cmenu-cartbar-total').textContent = formatMoney(cart.total_price);
    bar.hidden = false;
  }

  /* ---------------- Scrollbar ---------------- */
  function Scrollbar(grid, track, thumb) {
    if (!grid || !track || !thumb) return null;
    var dragging = false;

    function update() {
      var ratio = grid.clientWidth / grid.scrollWidth;
      if (ratio >= 0.999) { track.style.visibility = 'hidden'; return; }
      track.style.visibility = 'visible';
      var w = Math.max(ratio * track.clientWidth, 34);
      thumb.style.width = w + 'px';
      var max = grid.scrollWidth - grid.clientWidth;
      thumb.style.left = (max > 0 ? grid.scrollLeft / max : 0) * (track.clientWidth - w) + 'px';
    }
    function seek(x) {
      var r = track.getBoundingClientRect(), w = thumb.offsetWidth;
      var p = Math.min(Math.max((x - r.left - w / 2) / (r.width - w), 0), 1);
      grid.scrollLeft = p * (grid.scrollWidth - grid.clientWidth);
    }

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    track.addEventListener('pointerdown', function (e) {
      dragging = true; track.setPointerCapture(e.pointerId); seek(e.clientX);
    });
    track.addEventListener('pointermove', function (e) { if (dragging) seek(e.clientX); });
    track.addEventListener('pointerup', function () { dragging = false; });
    track.addEventListener('pointercancel', function () { dragging = false; });
    update();
    return { update: update };
  }

  /* ---------------- Section ---------------- */
  function initSection(root) {
    if (root.dataset.cmenuReady === '1') return;
    root.dataset.cmenuReady = '1';

    var id = root.dataset.sectionId;
    var nav = document.getElementById('cmenu-nav-' + id);
    var indicator = document.getElementById('cmenu-indicator-' + id);
    var grid = document.getElementById('cmenu-grid-' + id);
    var seeAll = document.getElementById('cmenu-seeall-' + id);
    var wrapper = nav && nav.closest('.cmenu__nav-wrapper');
    if (!nav || !grid) return;

    if (root.dataset.moneyFormat) moneyFormat = root.dataset.moneyFormat;

    var limit = root.dataset.productsPerPage || 12;
    var cache = {};
    var loading = false;
    var activeTab = nav.querySelector('.cmenu__tab.is-active') || nav.querySelector('.cmenu__tab');
    var bar = Scrollbar(grid,
      document.getElementById('cmenu-track-' + id),
      document.getElementById('cmenu-thumb-' + id));

    if (activeTab) cache[activeTab.dataset.handle] = grid.innerHTML;

    function moveIndicator(tab, animate) {
      if (!indicator || !tab) return;
      indicator.classList.toggle('is-animated', !!animate);
      indicator.style.width = tab.offsetWidth + 'px';
      indicator.style.transform = 'translateX(' + (tab.offsetLeft - nav.scrollLeft) + 'px)';
    }

    function setActive(tab) {
      if (activeTab) {
        activeTab.classList.remove('is-active');
        activeTab.setAttribute('aria-selected', 'false');
        var oi = activeTab.querySelector('.cmenu__tab-icon');
        if (oi && activeTab.dataset.iconInactive) oi.src = activeTab.dataset.iconInactive;
      }
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var ni = tab.querySelector('.cmenu__tab-icon');
      if (ni && tab.dataset.iconActive) ni.src = tab.dataset.iconActive;
      activeTab = tab;
      moveIndicator(tab, true);
      if (seeAll) seeAll.href = tab.dataset.url;
    }

    function paint(html) {
      grid.innerHTML = html;
      grid.scrollLeft = 0;
      grid.classList.remove('is-loading');
      if (bar) bar.update();
      loading = false;
    }

    function fetchCollection(handle) {
      return fetch('/collections/' + handle + '?view=cmenu&limit=' + limit,
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Request failed');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.querySelector('.cmenu__grid');
          return list ? list.innerHTML : '';
        });
    }

    nav.addEventListener('click', function (e) {
      var tab = e.target.closest('.cmenu__tab');
      if (!tab || tab === activeTab || loading) return;
      var handle = tab.dataset.handle;
      setActive(tab);
      tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });

      if (cache[handle]) { paint(cache[handle]); return; }

      loading = true;
      grid.classList.add('is-loading');
      fetchCollection(handle)
        .then(function (html) {
          cache[handle] = html || '<li class="cmenu__empty">No products found.</li>';
          paint(cache[handle]);
        })
        .catch(function () {
          grid.classList.remove('is-loading');
          loading = false;
          toast('Could not load that collection', true);
        });
    });

    nav.querySelectorAll('.cmenu__tab').forEach(function (tab) {
      var pre = function () {
        var h = tab.dataset.handle;
        if (!h || cache[h]) return;
        fetchCollection(h).then(function (html) { if (html) cache[h] = html; }).catch(function () {});
      };
      tab.addEventListener('mouseenter', pre, { once: true, passive: true });
      tab.addEventListener('touchstart', pre, { once: true, passive: true });
    });

    function checkNav() {
      if (!wrapper) return;
      var over = nav.scrollWidth > nav.clientWidth + 4;
      nav.style.justifyContent = over ? 'flex-start' : 'center';
      wrapper.classList.toggle('is-start', over && nav.scrollLeft > 8);
      wrapper.classList.toggle('is-end', over && nav.scrollLeft < nav.scrollWidth - nav.clientWidth - 8);
      moveIndicator(activeTab, false);
    }
    nav.addEventListener('scroll', checkNav, { passive: true });
    window.addEventListener('resize', checkNav, { passive: true });
    checkNav();
    moveIndicator(activeTab, false);
    setTimeout(function () { moveIndicator(activeTab, false); if (bar) bar.update(); }, 120);
  }

  /* ---------------- Delegated clicks ---------------- */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cmenu-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      runAdd(addBtn, addBtn.dataset.variantId);
      return;
    }

    var vb = e.target.closest('[data-cmenu-variants]');
    if (vb) {
      e.preventDefault();
      e.stopPropagation();
      var variants;
      try { variants = JSON.parse(vb.dataset.cmenuVariants); }
      catch (err) { toast('Could not load options', true); return; }
      Modal.open(vb.dataset.productTitle || 'Choose an option', variants);
    }
  });

  /* ---------------- Boot ---------------- */
  function dedupeShared() {
    // If multiple sections output the shared modal/cart-bar, keep the
    // first of each ID and drop the rest so IDs stay unique.
    var seen = {};
    document.querySelectorAll('[data-cmenu-shared]').forEach(function (el) {
      if (seen[el.id]) { el.parentNode.removeChild(el); }
      else { seen[el.id] = true; }
    });
  }

  function boot() {
    dedupeShared();
    Modal.init();
    document.querySelectorAll('.cmenu').forEach(initSection);
    refreshCart().catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.cmenu');
    if (root) initSection(root);
  });
  document.addEventListener('cmenu:cart:refresh', function () {
    refreshCart().catch(function () {});
  });
})();